import { render, staticRenderFns } from "./context-task.vue?vue&type=template&id=42eb06d7"
import script from "./context-task.vue?vue&type=script&lang=js"
export * from "./context-task.vue?vue&type=script&lang=js"
import style0 from "./context-task.vue?vue&type=style&index=0&id=42eb06d7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports